module.exports = __webpack_public_path__ + "img/15-1.984536b1.png";